import * as yup from 'yup';

export interface CobaltFormValues {
  apiKey: string;
}

export function cobaltConfigSchema(isExistingConfig: boolean) {
  return yup.object({
    apiKey: isExistingConfig ? yup.string().default('') : yup.string().trim().required('API Key is required'),
  });
}

export function getDefaultCobaltConfig(): CobaltFormValues {
  return { apiKey: '' };
}
